//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/components/activity/yuexiu/oouyanMini.vue